// @core/api/endpoints/analytics/list_available_data_sources.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAvailableDataSourcesResponse,
} from '../../../types/analytics';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/analytics';

/**
 * List available data sources
 * Returns all products and entity types available for analytics queries in the current tenant context.
 */
export async function ListAvailableDataSources(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAvailableDataSourcesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/data-sources`;
  const requestOptions = options;
  return client.get<ListAvailableDataSourcesResponse>(requestPath, { ...requestOptions, params });
}
